import React, {useContext} from 'react'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useBoolean} from '@containers/hooks'
import {Padding} from '../design-system/types'
import {TwCnt} from './containers'
import {PropsContext} from './context'

export const PopupContent = ({paddings}: {paddings: Padding}) => {
  const props = useContext(PropsContext)
  const {
    children,
    contentClassName,
    withoutContentOverflowScroll = false
  } = props

  const scrolledDown = useBoolean(false)
  const onScroll = (container: HTMLElement) => {
    if ((container.scrollTop !== 0) !== scrolledDown.value) {
      scrolledDown.setValue(container.scrollTop !== 0)
    }
  }

  return (
    <>
      {scrolledDown.value && <div className="mx-24 h-1 bg-grey-l60" />}
      {withoutContentOverflowScroll ? (
        <TwCnt className={contentClassName} $paddings={paddings}>
          {children}
        </TwCnt>
      ) : (
        <WithPerfectScrollbar
          onScrollY={onScroll}
          className="flex-1 flex flex-col"
        >
          <TwCnt className={contentClassName} $paddings={paddings}>
            {children}
          </TwCnt>
        </WithPerfectScrollbar>
      )}
    </>
  )
}
